import React from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import './LandingPage.css';
import { useEffect, useState, useRef } from 'react'
import * as Auth from 'aws-amplify/auth';
import { get } from '@aws-amplify/api';
import { AgGridReact} from "ag-grid-react";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { ModuleRegistry } from '@ag-grid-community/core';
import { ExcelExportModule } from '@ag-grid-enterprise/excel-export';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import AppLayout from './components/AppLayout';

ModuleRegistry.registerModules([ExcelExportModule]);

const myAPI="mktappapi";
let path = '/getButterflyTransactions';

// EditForm component for editing butterfly transaction details
function EditForm({ record, onBack }) {
  console.log("EditForm : record = ", record);

  // Initialize formData with all fields to avoid undefined values
  const [formData, setFormData] = useState({
    ...record,
    // Ensure all fields have default values
    security: record.security || '',
    expiration: record.expiration || '',
    targetDte: record.targetDte || 0,
    openTradeDate: record.openTradeDate || '',
    closeTradeDate: record.closeTradeDate || '',
    paperTrade: record.paperTrade || false,
    lastSale: record.lastSale || '0.00',
    lastSaleOpen: record.lastSaleOpen || record.lastSale || '0.00',
    lastSaleClose: record.lastSaleClose || record.lastSale || '0.00',
    lowerBreakeven: record.lowerBreakeven || '0.00',
    upperBreakeven: record.upperBreakeven || '0.00',
    openCost: record.openCost || '0.00',
    closeCost: record.closeCost || '0.00',
    maxGain: record.maxGain || '0.00',
    maxLoss: record.maxLoss || '0.00',
    commissionFee: record.commissionFee || '0.00',
    netAmountOpen: record.netAmountOpen || '0.00',
    netAmountClose: record.netAmountClose || '0.00',
    desiredProfitPercent: record.desiredProfitPercent || '0.00',
    desiredNetAmount: record.desiredNetAmount || '0.00',
    profitLossDollars: record.profitLossDollars || '0.00',
    profitLossPercent: record.profitLossPercent || '0.00',
    vixLastSale: record.vixLastSale || '0.00',
    vixChangePercent: record.vixChangePercent || '0.00',
    netVega: record.netVega || '0.00',
    netDelta: record.netDelta || '0.00',
    netGamma: record.netGamma || '0.00',
    netTheta: record.netTheta || '0.00',
    // Leg 1
    leg1Action: record.leg1Action || '',
    leg1Type: record.leg1Type || '',
    leg1Strike: record.leg1Strike || '0.00',
    leg1Quantity: record.leg1Quantity || 1,
    leg1Quote: record.leg1Quote || '0.00',
    leg1Delta: record.leg1Delta || '0.0000',
    leg1Cost: record.leg1Cost || '0.00',
    leg1CloseCost: record.leg1CloseCost || '0.00',
    leg1CloseQuote: record.leg1CloseQuote || '0.00',
    // Leg 2
    leg2Action: record.leg2Action || '',
    leg2Type: record.leg2Type || '',
    leg2Strike: record.leg2Strike || '0.00',
    leg2Quantity: record.leg2Quantity || 1,
    leg2Quote: record.leg2Quote || '0.00',
    leg2Delta: record.leg2Delta || '0.0000',
    leg2Cost: record.leg2Cost || '0.00',
    leg2CloseCost: record.leg2CloseCost || '0.00',
    leg2CloseQuote: record.leg2CloseQuote || '0.00',
    // Leg 3
    leg3Action: record.leg3Action || '',
    leg3Type: record.leg3Type || '',
    leg3Strike: record.leg3Strike || '0.00',
    leg3Quantity: record.leg3Quantity || 1,
    leg3Quote: record.leg3Quote || '0.00',
    leg3Delta: record.leg3Delta || '0.0000',
    leg3Cost: record.leg3Cost || '0.00',
    leg3CloseCost: record.leg3CloseCost || '0.00',
    leg3CloseQuote: record.leg3CloseQuote || '0.00',
  });
  const [showError, setShowError] = useState(false);
  const [displayMessage, setDisplayMessage] = useState("");

  console.log("EditForm : initialized formData = ", formData);

  // Helper function to safely parse dates
  const parseDateSafely = (dateStr) => {
    if (!dateStr || dateStr === '' || dateStr === 'null' || dateStr === 'Invalid Date') {
      return null;
    }
    try {
      let year, month, day;

      // Handle different date formats
      if (typeof dateStr === 'string') {
        // Check if it's MM-DD-YYYY format
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
          [month, day, year] = dateStr.split('-');
        }
        // Check if it's YYYY-MM-DD format
        else if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
          // Extract just the date part (before T if present)
          const datePart = dateStr.split('T')[0];
          [year, month, day] = datePart.split('-');
        }
        else {
          return null;
        }

        // Create date using constructor to avoid timezone issues
        // Month is 0-indexed in JavaScript Date
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

        if (isNaN(date.getTime())) {
          return null;
        }
        return date;
      } else if (dateStr instanceof Date) {
        return dateStr;
      } else {
        return null;
      }
    } catch (error) {
      console.log("Error parsing date:", dateStr, error);
      return null;
    }
  };

  // Date pickers state
  const [selectedExp, setSelectedExp] = useState(parseDateSafely(record.expiration));
  const [selectedOpenTradeDate, setSelectedOpenTradeDate] = useState(parseDateSafely(record.openTradeDate));
  const [selectedCloseTradeDate, setSelectedCloseTradeDate] = useState(parseDateSafely(record.closeTradeDate));

  const commissionClose = 0.65;

  // Initialize calculated fields on mount
  useEffect(() => {
    console.log("EditForm useEffect - initializing calculated fields");
    console.log("Initial formData:", formData);

    let updatedFormData = {...formData};
    const totalContracts = parseInt(formData.leg1Quantity || 1);

    // Calculate netAmountOpen if not already set
    const leg1QuoteOpen = parseFloat(formData.leg1Quote || 0);
    const leg2QuoteOpen = parseFloat(formData.leg2Quote || 0);
    const leg3QuoteOpen = parseFloat(formData.leg3Quote || 0);
    console.log("leg1QuoteOpen = " + leg1QuoteOpen + "\tleg2QuoteOpen = " + leg2QuoteOpen + "\tleg3QuoteOpen = " + leg3QuoteOpen);

    const sign1 = formData.leg1Action === "Sell" ? 1 : -1;
    const sign2 = formData.leg2Action === "Sell" ? 1 : -1;
    const sign3 = formData.leg3Action === "Sell" ? 1 : -1;
    updatedFormData.netAmountOpen = (sign1 * leg1QuoteOpen + sign2 * leg2QuoteOpen * 2 + sign3 * leg3QuoteOpen).toFixed(2);
    console.log("updatedFormData.netAmountOpen = " + updatedFormData.netAmountOpen);

    // Close quotes are already provided by the API (from getButterflyTransactions)
    // If not available, calculate from close costs as fallback
    if (!formData.leg1CloseQuote || parseFloat(formData.leg1CloseQuote) === 0) {
      if (formData.leg1CloseCost && parseFloat(formData.leg1CloseCost) !== 0) {
        const leg1Qty = parseInt(updatedFormData.leg1Quantity || 1);
        const leg1CloseSign = getOppositeAction(formData.leg1Action) === "Sell" ? 1 : -1;
        updatedFormData.leg1CloseQuote = Math.abs(parseFloat(formData.leg1CloseCost) / (leg1Qty * 100));
      }
    }

    if (!formData.leg2CloseQuote || parseFloat(formData.leg2CloseQuote) === 0) {
      if (formData.leg2CloseCost && parseFloat(formData.leg2CloseCost) !== 0) {
        const leg2Qty = parseInt(updatedFormData.leg2Quantity || 2);
        const leg2CloseSign = getOppositeAction(formData.leg2Action) === "Sell" ? 1 : -1;
        updatedFormData.leg2CloseQuote = Math.abs(parseFloat(formData.leg2CloseCost) / (leg2Qty * 100));
      }
    }

    if (!formData.leg3CloseQuote || parseFloat(formData.leg3CloseQuote) === 0) {
      if (formData.leg3CloseCost && parseFloat(formData.leg3CloseCost) !== 0) {
        const leg3Qty = parseInt(updatedFormData.leg3Quantity || 1);
        const leg3CloseSign = getOppositeAction(formData.leg3Action) === "Sell" ? 1 : -1;
        updatedFormData.leg3CloseQuote = Math.abs(parseFloat(formData.leg3CloseCost) / (leg3Qty * 100));
      }
    }

    // Net Amount Close is already provided by the API
    // If not available, calculate as fallback
    if (!formData.netAmountClose) {
      console.log("formData.netAmountClose is not set - calculating netAmountClose"); 
      const leg1QuoteClose = parseFloat(updatedFormData.leg1CloseQuote || 0);
      const leg2QuoteClose = parseFloat(updatedFormData.leg2CloseQuote || 0);
      const leg3QuoteClose = parseFloat(updatedFormData.leg3CloseQuote || 0);
      const closeSign1 = getOppositeAction(formData.leg1Action) === "Sell" ? 1 : -1;
      const closeSign2 = getOppositeAction(formData.leg2Action) === "Sell" ? 1 : -1;
      const closeSign3 = getOppositeAction(formData.leg3Action) === "Sell" ? 1 : -1;
      updatedFormData.netAmountClose = (closeSign1 * leg1QuoteClose + closeSign2 * leg2QuoteClose * 2 + closeSign3 * leg3QuoteClose).toFixed(2);
      console.log("updatedFormData.netAmountClose = " + updatedFormData.netAmountClose);
    }

    // Calculate desired net amount if desired profit percent is set
    if (formData.desiredProfitPercent) {
      const netAmount = parseFloat(updatedFormData.netAmountOpen || 0);
      const desiredProfit = parseFloat(formData.desiredProfitPercent || 0);
      let desiredNetAmount = 0;
      if (netAmount < 0) {
        desiredNetAmount = ((-1) * netAmount * desiredProfit / 100 + (-1) * netAmount).toFixed(2);
      } else {
        desiredNetAmount = (netAmount * desiredProfit / 100 + netAmount).toFixed(2);
      }
      updatedFormData.desiredNetAmount = desiredNetAmount;
    }

    console.log("Updated formData after initialization:", updatedFormData);
    setFormData(updatedFormData);
  }, []); // Run only once on mount

  const getOppositeAction = (action) => {
    return action === "Buy" ? "Sell" : "Buy";
  };

  const handleChange = (event) => {
    setShowError(false);
    const { name, value, type, checked } = event.target;

    let updatedFormData = {...formData};

    // Handle quantity changes with butterfly spread synchronization
    if (name.includes("Quantity")) {
      const legNum = parseInt(name.replace("leg", "").replace("Quantity", ""));
      let quantity = parseInt(value) || (legNum === 2 ? 2 : 1);

      // For a butterfly spread:
      // Leg 1 (index 0) = Leg 3 (index 2)
      // Leg 2 (index 1) = 2 × Leg 1 (must be even)

      let leg1Qty, leg2Qty, leg3Qty;

      if (legNum === 1 || legNum === 3) {
        // If changing leg 1 or leg 3, they should match
        leg1Qty = quantity;
        leg3Qty = quantity;
        leg2Qty = quantity * 2; // Always even
      } else if (legNum === 2) {
        // If changing leg 2, round to nearest even number
        leg2Qty = quantity % 2 === 0 ? quantity : quantity + 1;
        leg1Qty = leg2Qty / 2;
        leg3Qty = leg2Qty / 2;
      }

      // Update all three legs
      updatedFormData.leg1Quantity = leg1Qty;
      updatedFormData.leg2Quantity = leg2Qty;
      updatedFormData.leg3Quantity = leg3Qty;

      // Recalculate open costs per leg based on new quantities
      const leg1Quote = parseFloat(updatedFormData.leg1Quote || 0);
      const leg2Quote = parseFloat(updatedFormData.leg2Quote || 0);
      const leg3Quote = parseFloat(updatedFormData.leg3Quote || 0);

      const leg1Sign = updatedFormData.leg1Action === "Sell" ? 1 : -1;
      const leg2Sign = updatedFormData.leg2Action === "Sell" ? 1 : -1;
      const leg3Sign = updatedFormData.leg3Action === "Sell" ? 1 : -1;

      updatedFormData.leg1Cost = (leg1Sign * leg1Quote * leg1Qty * 100);
      updatedFormData.leg2Cost = (leg2Sign * leg2Quote * leg2Qty * 100);
      updatedFormData.leg3Cost = (leg3Sign * leg3Quote * leg3Qty * 100);

      // Recalculate close costs per leg based on new quantities
      const leg1CloseQuote = parseFloat(updatedFormData.leg1CloseQuote || 0);
      const leg2CloseQuote = parseFloat(updatedFormData.leg2CloseQuote || 0);
      const leg3CloseQuote = parseFloat(updatedFormData.leg3CloseQuote || 0);

      const leg1CloseSign = getOppositeAction(updatedFormData.leg1Action) === "Sell" ? 1 : -1;
      const leg2CloseSign = getOppositeAction(updatedFormData.leg2Action) === "Sell" ? 1 : -1;
      const leg3CloseSign = getOppositeAction(updatedFormData.leg3Action) === "Sell" ? 1 : -1;

      updatedFormData.leg1CloseCost = (leg1CloseSign * leg1CloseQuote * leg1Qty * 100);
      updatedFormData.leg2CloseCost = (leg2CloseSign * leg2CloseQuote * leg2Qty * 100);
      updatedFormData.leg3CloseCost = (leg3CloseSign * leg3CloseQuote * leg3Qty * 100);
    } else {
      updatedFormData[name] = type === "checkbox" ? checked : value;
    }

    // Calculate leg quotes when cost changes
    if (name.includes("leg") && name.includes("Cost") && !name.includes("Close")) {
      const legNum = name.match(/leg(\d)/)[1];
      const legQuantity = parseInt(updatedFormData[`leg${legNum}Quantity`] || 1);
      const legAction = updatedFormData[`leg${legNum}Action`];
      const sign = legAction === "Sell" ? 1 : -1;
      // Keep 4 decimal precision for quotes
      updatedFormData[`leg${legNum}Quote`] = Math.abs(parseFloat(value || 0) / (legQuantity * 100));
    }

    // Calculate close costs when close quotes change
    if (name.includes("CloseQuote")) {
      const legNum = name.match(/leg(\d)/)[1];
      const legQuantity = parseInt(updatedFormData[`leg${legNum}Quantity`] || 1);
      const legAction = updatedFormData[`leg${legNum}Action`];
      const closeSign = getOppositeAction(legAction) === "Sell" ? 1 : -1;
      updatedFormData[`leg${legNum}CloseCost`] = closeSign * parseFloat(value || 0) * legQuantity * 100;
    }

    // Calculate Net Amount Open (per contract basis: leg1=1, leg2=2, leg3=1)
    const leg1QuoteOpen = parseFloat(updatedFormData.leg1Quote || 0);
    const leg2QuoteOpen = parseFloat(updatedFormData.leg2Quote || 0);
    const leg3QuoteOpen = parseFloat(updatedFormData.leg3Quote || 0);
    const sign1 = formData.leg1Action === "Sell" ? 1 : -1;
    const sign2 = formData.leg2Action === "Sell" ? 1 : -1;
    const sign3 = formData.leg3Action === "Sell" ? 1 : -1;
    updatedFormData.netAmountOpen = (sign1 * leg1QuoteOpen + sign2 * leg2QuoteOpen * 2 + sign3 * leg3QuoteOpen).toFixed(2);

    // Calculate Open Cost with commission fee
    // Commission: leg1_qty * 0.65 + leg2_qty * 0.65 + leg3_qty * 0.65
    const leg1CostOpen = parseFloat(updatedFormData.leg1Cost || 0);
    const leg2CostOpen = parseFloat(updatedFormData.leg2Cost || 0);
    const leg3CostOpen = parseFloat(updatedFormData.leg3Cost || 0);
    const leg1Qty = parseInt(updatedFormData.leg1Quantity || 0);
    const leg2Qty = parseInt(updatedFormData.leg2Quantity || 0);
    const leg3Qty = parseInt(updatedFormData.leg3Quantity || 0);
    const openCommissionFee = leg1Qty * 0.65 + leg2Qty * 0.65 + leg3Qty * 0.65;
    let openCost = leg1CostOpen + leg2CostOpen + leg3CostOpen;
    if (openCost < 0) {
      openCost = openCost + (-1) * openCommissionFee;
    } else {
      openCost = openCost + openCommissionFee;
    }
    updatedFormData.openCost = openCost.toFixed(2);

    // Calculate Net Amount Close
    console.log("Calculating netAmountClose in handleChange");
    const leg1QuoteClose = parseFloat(updatedFormData.leg1CloseQuote || 0);
    const leg2QuoteClose = parseFloat(updatedFormData.leg2CloseQuote || 0);
    const leg3QuoteClose = parseFloat(updatedFormData.leg3CloseQuote || 0);
    const closeSign1 = getOppositeAction(formData.leg1Action) === "Sell" ? 1 : -1;
    const closeSign2 = getOppositeAction(formData.leg2Action) === "Sell" ? 1 : -1;
    const closeSign3 = getOppositeAction(formData.leg3Action) === "Sell" ? 1 : -1;
    updatedFormData.netAmountClose = (closeSign1 * leg1QuoteClose + closeSign2 * leg2QuoteClose * 2 + closeSign3 * leg3QuoteClose).toFixed(2);
    console.log("updatedFormData.netAmountClose = " + updatedFormData.netAmountClose);

    // Calculate close cost with commission fee
    // Commission: leg1_qty * 0.65 + leg2_qty * 0.65 + leg3_qty * 0.65
    const leg1CostClose = parseFloat(updatedFormData.leg1CloseCost || 0);
    const leg2CostClose = parseFloat(updatedFormData.leg2CloseCost || 0);
    const leg3CostClose = parseFloat(updatedFormData.leg3CloseCost || 0);
    const closeCommissionFee = leg1Qty * 0.65 + leg2Qty * 0.65 + leg3Qty * 0.65;
    let closeCost = leg1CostClose + leg2CostClose + leg3CostClose;
    if (closeCost < 0) {
      closeCost = closeCost + (-1) * closeCommissionFee;
    } else {
      closeCost = closeCost + closeCommissionFee;
    }
    updatedFormData.closeCost = closeCost.toFixed(2);

    // Calculate Desired Net Amount (only updates desired fields, not actual profit/loss)
    if (name === "desiredProfitPercent") {
      const netAmount = parseFloat(updatedFormData.netAmountOpen || 0);
      const desiredProfit = parseFloat(value || 0);
      let desiredNetAmount = 0;
      if (netAmount < 0) {
        desiredNetAmount = ((-1) * netAmount * desiredProfit / 100 + (-1) * netAmount).toFixed(2);
      } else {
        desiredNetAmount = (netAmount * desiredProfit / 100 + netAmount).toFixed(2);
      }
      updatedFormData.desiredNetAmount = desiredNetAmount;
    } else {
      // Only calculate actual Profit/Loss when not changing desired profit
      const openCost = parseFloat(updatedFormData.openCost || 0);
      const closeCost = parseFloat(updatedFormData.closeCost || 0);
      updatedFormData.profitLossDollars = (closeCost + openCost).toFixed(2);
      if (openCost !== 0) {
        updatedFormData.profitLossPercent = ((parseFloat(updatedFormData.profitLossDollars) / Math.abs(openCost)) * 100).toFixed(2);
      }
    }

    // Calculate Max Gain, Max Loss, and Breakeven (matches ButterflyOptionsLegs.js)
    const leg1Strike = parseFloat(updatedFormData.leg1Strike || 0);
    const leg2Strike = parseFloat(updatedFormData.leg2Strike || 0);
    const leg3Strike = parseFloat(updatedFormData.leg3Strike || 0);

    if (leg1Strike > 0 && leg2Strike > 0 && leg3Strike > 0) {
      // Sort strikes to get K1 (lower), K2 (middle), K3 (upper)
      const strikes = [
        { strike: leg1Strike, quote: parseFloat(updatedFormData.leg1Quote || 0), qty: parseInt(updatedFormData.leg1Quantity || 1) },
        { strike: leg2Strike, quote: parseFloat(updatedFormData.leg2Quote || 0), qty: parseInt(updatedFormData.leg2Quantity || 2) },
        { strike: leg3Strike, quote: parseFloat(updatedFormData.leg3Quote || 0), qty: parseInt(updatedFormData.leg3Quantity || 1) }
      ].sort((a, b) => a.strike - b.strike);

      const K1 = strikes[0].strike;
      const K2 = strikes[1].strike;
      const K3 = strikes[2].strike;
      const wingQuantity = strikes[0].qty;

      // Calculate net debit per share
      const lowerCost = strikes[0].quote;
      const middleCredit = strikes[1].quote;
      const upperCost = strikes[2].quote;
      const Debit = (lowerCost + upperCost) - (middleCredit * 2);

      // Max gain calculation (backend line 231)
      const maxGainPerShare = (K2 - K1) - Debit;

      // Max loss calculation using tail payoffs (backend lines 235-240)
      const tailConstant = (2 * K2) - K1 - K3;
      const upperTailPayoff = tailConstant - Debit;
      const lowerTailPayoff = -Debit;
      const maxLossPerShare = Math.min(lowerTailPayoff, upperTailPayoff);

      // Total max gain/loss
      updatedFormData.maxGain = (maxGainPerShare * 100 * wingQuantity).toFixed(2);
      updatedFormData.maxLoss = (maxLossPerShare * 100 * wingQuantity).toFixed(2);

      // Breakeven calculation
      const netDebitPerShare = (lowerCost + upperCost) - (middleCredit * 2);
      updatedFormData.lowerBreakeven = (K1 + netDebitPerShare).toFixed(2);
      updatedFormData.upperBreakeven = (K3 - netDebitPerShare).toFixed(2);
    }

    setFormData(updatedFormData);
  };

  const handleChangeExpDate = (date) => {
    if (!date) {
      setSelectedExp(null);
      setFormData(prevFormData => ({ ...prevFormData, expiration: '' }));
      return;
    }
    const formattedDate = formatDate(date);
    setSelectedExp(new Date(date));
    setFormData(prevFormData => ({ ...prevFormData, expiration: formattedDate }));
  };

  const handleChangeOpenDate = (date) => {
    if (!date) {
      setSelectedOpenTradeDate(null);
      setFormData(prevFormData => ({ ...prevFormData, openTradeDate: '' }));
      return;
    }
    const formattedDate = formatDate(date);
    setSelectedOpenTradeDate(new Date(date));
    setFormData(prevFormData => ({ ...prevFormData, openTradeDate: formattedDate }));
  };

  const handleChangeCloseDate = (date) => {
    if (!date) {
      setSelectedCloseTradeDate(null);
      setFormData(prevFormData => ({ ...prevFormData, closeTradeDate: '' }));
      return;
    }
    const formattedDate = formatDate(date);
    setSelectedCloseTradeDate(new Date(date));
    setFormData(prevFormData => ({ ...prevFormData, closeTradeDate: formattedDate }));
  };

  const formatDate = (dateInput) => {
    if (!dateInput || dateInput === "") {
      return "";
    }

    // If it's already a Date object, use it directly
    let date;
    if (dateInput instanceof Date) {
      date = dateInput;
    } else {
      // If it's a string, parse it
      date = new Date(dateInput);
    }

    // Extract components using local timezone (not UTC)
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleReset = () => {
    setShowError(false);
    setFormData(record);
    setSelectedExp(parseDateSafely(record.expiration));
    setSelectedOpenTradeDate(parseDateSafely(record.openTradeDate));
    setSelectedCloseTradeDate(parseDateSafely(record.closeTradeDate));
  };

  const handleSubmit = async () => {
    console.log("Executing handleSubmit");
    console.log("handleSubmit : formData = ", formData);

    try {
      setShowError(false);
      setDisplayMessage("Saving transaction...");

      // Prepare transaction data for API - field names must match database columns exactly
      const transactionData = {
        id: formData.id,
        email: formData.email,
        Security: formData.security,
        Expiration: formData.expiration,
        LastSale: parseFloat(formData.lastSale || 0),
        LastSaleOpen: parseFloat(formData.lastSaleOpen || 0),
        LastSaleClose: parseFloat(formData.lastSaleClose || formData.lastSale || 0),
        TargetDTE: formData.targetDte || 0,
        openTradeDate: formData.openTradeDate,
        closeTradeDate: formData.closeTradeDate || null,
        OpenCost: parseFloat(formData.openCost || 0),
        closeCost: parseFloat(formData.closeCost || 0),  // lowercase 'c'
        MaxGain: parseFloat(formData.maxGain || 0),
        MaxLoss: parseFloat(formData.maxLoss || 0),
        lowerBreakEven: parseFloat(formData.lowerBreakeven || 0),
        upperBreakEven: parseFloat(formData.upperBreakeven || 0),
        NetAmount: parseFloat(formData.netAmountOpen || 0),
        netAmountClose: parseFloat(formData.netAmountClose || 0),
        NetDelta: parseFloat(formData.netDelta || 0),
        NetGamma: parseFloat(formData.netGamma || 0),
        NetTheta: parseFloat(formData.netTheta || 0),
        NetVega: parseFloat(formData.netVega || 0),
        CommissionFee: parseFloat(formData.commissionFee || 0),
        VIXLastSale: parseFloat(formData.vixLastSale || 0),
        VIXChangePercent: parseFloat(formData.vixChangePercent || 0),
        ProfitLossDollars: parseFloat(formData.profitLossDollars || 0),
        ProfitLossPercent: parseFloat(formData.profitLossPercent || 0),
        paperTrade: formData.paperTrade ? 'true' : 'false',

        // Leg 1
        Leg1Action: formData.leg1Action,
        Leg1Type: formData.leg1Type,
        Leg1Strike: parseFloat(formData.leg1Strike || 0),
        Leg1Quantity: parseInt(formData.leg1Quantity || 0),
        Leg1Quote: parseFloat(formData.leg1Quote || 0),
        Leg1ActualDelta: parseFloat(formData.leg1Delta || 0),
        Leg1Cost: parseFloat(formData.leg1Cost || 0),
        leg1CloseCost: parseFloat(formData.leg1CloseCost || 0),

        // Leg 2
        Leg2Action: formData.leg2Action,
        Leg2Type: formData.leg2Type,
        Leg2Strike: parseFloat(formData.leg2Strike || 0),
        Leg2Quantity: parseInt(formData.leg2Quantity || 0),
        Leg2Quote: parseFloat(formData.leg2Quote || 0),
        Leg2ActualDelta: parseFloat(formData.leg2Delta || 0),
        Leg2Cost: parseFloat(formData.leg2Cost || 0),
        leg2CloseCost: parseFloat(formData.leg2CloseCost || 0),

        // Leg 3
        Leg3Action: formData.leg3Action,
        Leg3Type: formData.leg3Type,
        Leg3Strike: parseFloat(formData.leg3Strike || 0),
        Leg3Quantity: parseInt(formData.leg3Quantity || 0),
        Leg3Quote: parseFloat(formData.leg3Quote || 0),
        Leg3ActualDelta: parseFloat(formData.leg3Delta || 0),
        Leg3Cost: parseFloat(formData.leg3Cost || 0),
        leg3CloseCost: parseFloat(formData.leg3CloseCost || 0),
      };

      console.log("Transaction data to save:", transactionData);

      // Prepare payload for API
      const payload = {
        email: formData.email,
        transactionData: transactionData
      };

      const myAPI = "mktappapi";
      const path = '/storeButterflyTransaction/' + encodeURIComponent(JSON.stringify(payload));

      console.log("Calling API:", path);

      const response = await get({
        apiName: myAPI,
        path: path,
      }).response;

      const result = await response.body.json();
      console.log("Save response:", result);

      if (result.error) {
        setShowError(true);
        setDisplayMessage("Error saving transaction: " + result.error);
      } else {
        setDisplayMessage("Transaction updated successfully!");
        setTimeout(() => {
          onBack();
        }, 1500);
      }
    } catch (error) {
      console.log("Error in handleSubmit:", error);
      setShowError(true);
      setDisplayMessage("Error saving transaction: " + error.message);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '8px 12px',
    border: '1px solid rgba(209, 213, 219, 1)',
    borderRadius: '6px',
    fontSize: '14px'
  };

  const readOnlyInputStyle = {
    ...inputStyle,
    background: 'rgba(243, 244, 246, 1)'
  };

  const labelStyle = {
    fontWeight: '600',
    color: 'rgba(0, 0, 0, 0.8)',
    display: 'block',
    marginBottom: '8px'
  };

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      {/* Page Title */}
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
          Edit Butterfly: {formData.security}
        </h1>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            id="paperTrade"
            name="paperTrade"
            checked={formData.paperTrade || false}
            onChange={handleChange}
            style={{ width: '18px', height: '18px' }}
          />
          <span style={{ fontWeight: '600', color: 'rgba(107, 114, 128, 1)' }}>Paper Trade</span>
        </label>
      </div>

      {showError && <div className="blink_me_red" style={{ marginBottom: '16px', textAlign: 'center', padding: '12px' }}>{displayMessage}</div>}
      {!showError && displayMessage && <div className="blink_me" style={{ marginBottom: '16px', textAlign: 'center', padding: '12px', color: 'green' }}>{displayMessage}</div>}

      {/* Trade Details Panel */}
      <div className="landing-panel" style={{ marginBottom: '24px' }}>
        <div className="landing-panel-header">
          <h2 className="landing-panel-title">Trade Details</h2>
        </div>
        <div className="landing-panel-content">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
            <div>
              <label style={labelStyle}>Security</label>
              <input type="text" name="security" value={formData.security} onChange={handleChange} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Expiration</label>
              <DatePicker selected={selectedExp} onChange={handleChangeExpDate} dateFormat="yyyy-MM-dd" className="date-picker-input" />
            </div>
            <div>
              <label style={labelStyle}>Open Trade Date</label>
              <DatePicker selected={selectedOpenTradeDate} onChange={handleChangeOpenDate} dateFormat="yyyy-MM-dd" className="date-picker-input" />
            </div>
            <div>
              <label style={labelStyle}>Close Trade Date</label>
              <DatePicker selected={selectedCloseTradeDate} onChange={handleChangeCloseDate} dateFormat="yyyy-MM-dd" className="date-picker-input" />
            </div>
          </div>
        </div>
      </div>

      {/* Legs Panel */}
      <div className="landing-panel" style={{ marginBottom: '24px' }}>
        <div className="landing-panel-header">
          <h2 className="landing-panel-title">Option Legs</h2>
        </div>
        <div className="landing-panel-content">
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr style={{ background: 'rgba(249, 250, 251, 1)' }}>
                  <th style={{ padding: '12px 8px', textAlign: 'left', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Leg Type</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Qty</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Strike</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Delta</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Open Quote</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Open Cost</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Close Quote</th>
                  <th style={{ padding: '12px 8px', textAlign: 'center', fontWeight: '600', borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>Close Cost</th>
                </tr>
              </thead>
              <tbody>
                {[1, 2, 3].map((num) => (
                  <tr key={num} style={{ borderBottom: '1px solid rgba(229, 231, 235, 1)' }}>
                    <td style={{ padding: '12px 8px', fontWeight: '500' }}>{num} - {formData[`leg${num}Action`]} {formData[`leg${num}Type`]}</td>
                    <td style={{ padding: '8px' }}>
                      <input
                        type="number"
                        name={`leg${num}Quantity`}
                        value={formData[`leg${num}Quantity`]}
                        onChange={handleChange}
                        min={num === 2 ? "2" : "1"}
                        step={num === 2 ? "2" : "1"}
                        style={{ ...inputStyle, width: '60px', textAlign: 'center' }}
                      />
                    </td>
                    <td style={{ padding: '8px' }}><input type="text" name={`leg${num}Strike`} value={formData[`leg${num}Strike`]} onChange={handleChange} style={{ ...inputStyle, width: '80px', textAlign: 'center' }} /></td>
                    <td style={{ padding: '8px' }}><input type="text" name={`leg${num}Delta`} value={Math.round(parseFloat(formData[`leg${num}Delta`] || 0) * 100)} onChange={handleChange} style={{ ...inputStyle, width: '60px', textAlign: 'center' }} /></td>
                    <td style={{ padding: '8px' }}><input type="text" value={formData[`leg${num}Quote`]} readOnly style={{ ...readOnlyInputStyle, width: '80px', textAlign: 'center' }} /></td>
                    <td style={{ padding: '8px' }}><input type="text" name={`leg${num}Cost`} value={formData[`leg${num}Cost`] ?? ''} onChange={handleChange} style={{ ...inputStyle, width: '90px', textAlign: 'center' }} /></td>
                    <td style={{ padding: '8px' }}><input type="text" value={formData[`leg${num}CloseQuote`] || "0.00"} readOnly style={{ ...readOnlyInputStyle, width: '80px', textAlign: 'center' }} /></td>
                    <td style={{ padding: '8px' }}><input type="text" name={`leg${num}CloseCost`} value={formData[`leg${num}CloseCost`] ?? ''} onChange={handleChange} style={{ ...inputStyle, width: '90px', textAlign: 'center' }} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Market & Audit Panel */}
      <div className="landing-panel" style={{ marginBottom: '24px' }}>
        <div className="landing-panel-header">
          <h2 className="landing-panel-title">Market & Audit</h2>
        </div>
        <div className="landing-panel-content">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={labelStyle}>Last Sale Open</label>
              <input type="text" name="lastSaleOpen" value={formData.lastSaleOpen} onChange={handleChange} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Net Amt Open</label>
              <input type="text" value={formData.netAmountOpen} readOnly style={readOnlyInputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Open Cost</label>
              <input type="text" value={formData.openCost} readOnly style={{...readOnlyInputStyle, minWidth: '120px'}} />
            </div>
            <div>
              <label style={labelStyle}>VIX Last</label>
              <input type="text" value={formData.vixLastSale} readOnly style={readOnlyInputStyle} />
            </div>
            <div>
              <label style={labelStyle}>VIX Change %</label>
              <input type="text" value={formData.vixChangePercent} readOnly style={readOnlyInputStyle} />
            </div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px' }}>
            <div>
              <label style={labelStyle}>Last Sale Close</label>
              <input type="text" name="lastSale" value={formData.lastSale} onChange={handleChange} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Net Amt Close</label>
              <input type="text" value={formData.netAmountClose || "0.00"} readOnly style={readOnlyInputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Close Cost + Fee</label>
              <input type="text" value={formData.closeCost} readOnly style={{...readOnlyInputStyle, minWidth: '120px'}} />
            </div>
          </div>
        </div>
      </div>

      {/* Greeks Panel */}
      <div className="landing-panel" style={{ marginBottom: '24px' }}>
        <div className="landing-panel-header">
          <h2 className="landing-panel-title">Net Greeks</h2>
        </div>
        <div className="landing-panel-content">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
            <div>
              <label style={labelStyle}>Net Vega</label>
              <input type="text" value={formData.netVega} readOnly style={readOnlyInputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Net Delta</label>
              <input type="text" value={formData.netDelta} readOnly style={readOnlyInputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Net Gamma</label>
              <input type="text" value={formData.netGamma} readOnly style={readOnlyInputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Net Theta</label>
              <input type="text" value={formData.netTheta} readOnly style={readOnlyInputStyle} />
            </div>
          </div>
        </div>
      </div>

      {/* Performance Panel */}
      <div className="landing-panel" style={{ marginBottom: '24px' }}>
        <div className="landing-panel-header">
          <h2 className="landing-panel-title">Performance</h2>
        </div>
        <div className="landing-panel-content">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '24px' }}>
            {/* Profit/Loss Display */}
            <div style={{
              background: 'rgba(249, 250, 251, 1)',
              borderRadius: '12px',
              padding: '24px',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '14px', color: 'rgba(107, 114, 128, 1)', marginBottom: '8px', fontWeight: '600' }}>
                Total Profit / Loss
              </div>
              <div style={{
                fontSize: '32px',
                fontWeight: '700',
                color: parseFloat(formData.profitLossDollars) >= 0 ? '#10b981' : '#ef4444'
              }}>
                ${formData.profitLossDollars}
              </div>
              <div style={{
                fontSize: '20px',
                fontWeight: '600',
                color: parseFloat(formData.profitLossPercent) >= 0 ? '#10b981' : '#ef4444',
                marginTop: '4px'
              }}>
                {formData.profitLossPercent}%
              </div>
            </div>

            {/* Targets Grid */}
            <div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                <div>
                  <label style={labelStyle}>Desired Profit %</label>
                  <input type="text" name="desiredProfitPercent" value={formData.desiredProfitPercent} onChange={handleChange} style={inputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Desired Net Amt</label>
                  <input type="text" value={formData.desiredNetAmount} readOnly style={readOnlyInputStyle} />
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '16px' }}>
                <div>
                  <label style={labelStyle}>Max Gain</label>
                  <input type="text" value={formData.maxGain} readOnly style={readOnlyInputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Max Loss</label>
                  <input type="text" value={formData.maxLoss} readOnly style={{ ...readOnlyInputStyle, color: '#dc2626' }} />
                </div>
                <div>
                  <label style={labelStyle}>Lower BE</label>
                  <input type="text" value={formData.lowerBreakeven} readOnly style={readOnlyInputStyle} />
                </div>
                <div>
                  <label style={labelStyle}>Upper BE</label>
                  <input type="text" value={formData.upperBreakeven} readOnly style={readOnlyInputStyle} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '24px' }}>
        <button
          onClick={onBack}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(107, 114, 128, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          Back
        </button>
        <button
          onClick={handleReset}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          Reset
        </button>
        <button
          onClick={handleSubmit}
          style={{
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

const MyPortfolioButterfly = ({ signOut }) => {

  console.log("Executing MyPortfolioButterfly");
  const navigate = useNavigate();
  const location = useLocation();

  let numberOfChecked=useRef(0);
  let deleteIds=useRef([]);
  let email=useRef();
  const [forceRender, setForceRender]=useState(false);
  const [error,setError]=useState('');
  const [displayMessage, setDisplayMessage]=useState('');
  let calledGetMyTransactions = useRef(false);
  let [recsWereDeleted, setRecsWereDeleted] = useState(-1);
  let [isEditing, setIsEditing] = useState(false);
  let selectedRecord = useRef();
  let unrealizedProfit = useRef(0);
  let realizedProfit = useRef(0);
  let investedInMarket = useRef(0);

  const getUserInfo = async () => {
    try {
      await Auth.fetchAuthSession();
      const user = await Auth.fetchUserAttributes();
      console.log("getUserInfo : email = " + JSON.stringify(user.email));
      email.current = await user.email;
      return "done";
    } catch (error) {
      console.log("Error in getUserInfo: ", error);
      return "error";
    }
  };

  let analysis=useRef([]);
  const [rowDataState,setRowDataSate]=useState([]);
  let rowdata=[];

  async function getMyTransactions(email) {
    console.log("Executing getMyTransactions");
    console.log("getMyTransactions : email = "+email);

    calledGetMyTransactions.current = true;
    path = '/getButterflyTransactions';

    var passApiStr=path + "/" + email;
    console.log("passApiStr = "+passApiStr);

    const response = await get({
      apiName: myAPI,
      path: passApiStr,
    }).response;
    let resp = await response.body.json();

    await Promise.resolve(resp)
       .then(async () => {
         console.log("getMyTransactions : response = " + JSON.stringify(resp));
         console.log(resp);
         var count = Object.keys(resp).length;
         analysis.current=[];
         console.log("getMyTransactions : count = "+ count);
         if (count>0){
          analysis.current=[];
          for (var i=0; i<count; i++) {
            let responseObj = JSON.parse(resp[i]);
            console.log("getMyTransactions : responseObj = ", responseObj);
            analysis.current.push(responseObj);
          }
          console.log("getMyTransactions : analysis.length = " +analysis.current.length);
         }
       })
      .then(() => {
        loadRowData();
      })
       .catch(error => {
         console.log(error)
       })
  }

  function loadRowData() {
    console.log ("Executing loadRowData");
    console.log ("loadRowData : analysis = "+ JSON.stringify(analysis.current));

    if (typeof(analysis.current)!='undefined') {
      var count=analysis.current.length;
      console.log ("loadRowData : analysis length= "+count);

      if (count === 0) {
        rowdata = [];
        setRowDataSate(rowdata);
      }

      unrealizedProfit.current = 0;
      realizedProfit.current = 0;
      investedInMarket.current = 0;

      for (let key=0; key<count; key++) {
        let recObj = analysis.current[key];
        console.log("loadRowData : recObj = ", recObj);

        let closeTradeDate = "";
        if (recObj["CloseTradeDate"] && recObj["CloseTradeDate"].toString().trim().toLowerCase() !== "null") {
          closeTradeDate = recObj["CloseTradeDate"];
        }

        // Calculate profit/loss
        let profitLossDollars = parseFloat(recObj["ProfitLossDollars"] || 0);
        let profitLossPercent = parseFloat(recObj["ProfitLossPercent"] || 0);
        let isPaperTrade = recObj["PaperTrade"] === 'true' || recObj["PaperTrade"] === true;

        // Exclude paper trades from profit and invested calculations
        if (!isPaperTrade) {
          if (closeTradeDate) {
            realizedProfit.current += profitLossDollars;
          } else {
            unrealizedProfit.current += profitLossDollars;
            investedInMarket.current += Math.abs(parseFloat(recObj["OpenCost"] || 0));
          }
        }

        rowdata[key]={
          email: email.current,
          id: recObj["id"],
          security: recObj["Security"],
          expiration: recObj["Expiration"],
          lastSale: parseFloat(recObj["LastSale"]).toFixed(2),
          lastSaleOpen: parseFloat(recObj["LastSaleOpen"] || recObj["LastSale"]).toFixed(2),
          lastSaleClose: parseFloat(recObj["LastSaleClose"] || recObj["LastSale"]).toFixed(2),
          targetDte: parseInt(recObj["TargetDTE"]),
          openTradeDate: recObj["OpenTradeDate"],
          closeTradeDate: closeTradeDate,
          openCost: parseFloat(recObj["OpenCost"]).toFixed(2),
          closeCost: parseFloat(recObj["CloseCost"]).toFixed(2),
          maxGain: parseFloat(recObj["MaxGain"]).toFixed(2),
          maxLoss: parseFloat(recObj["MaxLoss"]).toFixed(2),
          lowerBreakeven: parseFloat(recObj["LowerBreakeven"] || 0).toFixed(2),
          upperBreakeven: parseFloat(recObj["UpperBreakeven"] || 0).toFixed(2),
          netAmount: parseFloat(recObj["NetAmount"]).toFixed(2),
          netDelta: parseFloat(recObj["NetDelta"]).toFixed(2),
          netGamma: parseFloat(recObj["NetGamma"]).toFixed(2),
          netTheta: parseFloat(recObj["NetTheta"]).toFixed(2),
          netVega: parseFloat(recObj["NetVega"]).toFixed(2),
          commissionFee: parseFloat(recObj["CommissionFee"]).toFixed(2),
          vixLastSale: parseFloat(recObj["VIXLastSale"]).toFixed(2),
          vixChangePercent: parseFloat(recObj["VIXChangePercent"]).toFixed(2),
          profitLossDollars: profitLossDollars.toFixed(2),
          profitLossPercent: profitLossPercent.toFixed(2),
          paperTrade: isPaperTrade,

          // Leg 1
          leg1Action: recObj["Leg1Action"],
          leg1Type: recObj["Leg1Type"],
          leg1Strike: parseFloat(recObj["Leg1Strike"]).toFixed(2),
          leg1Quantity: parseInt(recObj["Leg1Quantity"]),
          leg1Quote: parseFloat(recObj["Leg1Quote"]),
          leg1Delta: parseFloat(recObj["Leg1ActualDelta"]).toFixed(4),
          leg1Label: recObj["Leg1Label"],
          leg1Cost: parseFloat(recObj["Leg1Cost"] || 0),
          leg1CloseCost: parseFloat(recObj["leg1CloseCost"] || 0),
          leg1CloseQuote: parseFloat(recObj["leg1CloseQuote"] || 0),

          // Leg 2
          leg2Action: recObj["Leg2Action"],
          leg2Type: recObj["Leg2Type"],
          leg2Strike: parseFloat(recObj["Leg2Strike"]).toFixed(2),
          leg2Quantity: parseInt(recObj["Leg2Quantity"]),
          leg2Quote: parseFloat(recObj["Leg2Quote"]),
          leg2Delta: parseFloat(recObj["Leg2ActualDelta"]).toFixed(4),
          leg2Label: recObj["Leg2Label"],
          leg2Cost: parseFloat(recObj["Leg2Cost"] || 0),
          leg2CloseCost: parseFloat(recObj["leg2CloseCost"] || 0),
          leg2CloseQuote: parseFloat(recObj["leg2CloseQuote"] || 0),

          // Leg 3
          leg3Action: recObj["Leg3Action"],
          leg3Type: recObj["Leg3Type"],
          leg3Strike: parseFloat(recObj["Leg3Strike"]).toFixed(2),
          leg3Quantity: parseInt(recObj["Leg3Quantity"]),
          leg3Quote: parseFloat(recObj["Leg3Quote"]),
          leg3Delta: parseFloat(recObj["Leg3ActualDelta"]).toFixed(4),
          leg3Label: recObj["Leg3Label"],
          leg3Cost: parseFloat(recObj["Leg3Cost"] || 0),
          leg3CloseCost: parseFloat(recObj["leg3CloseCost"] || 0),
          leg3CloseQuote: parseFloat(recObj["leg3CloseQuote"] || 0),

          netAmountClose: parseFloat(recObj["NetAmountClose"] || 0).toFixed(2),
        };
      }
      console.log ("loadRowData : rowdata = ", rowdata);
      setRowDataSate(rowdata);
    }
  }

  // Helper function to format date as MM-DD-YYYY for grid display
  const formatDateForGrid = (dateStr) => {
    if (!dateStr || dateStr === '' || dateStr === 'null') return '';
    try {
      let year, month, day;

      // Handle different date formats
      if (typeof dateStr === 'string') {
        // Check if it's MM-DD-YYYY format (already formatted)
        if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
          return dateStr; // Already in correct format
        }
        // Check if it's YYYY-MM-DD format
        else if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) {
          // Extract just the date part (before T if present)
          const datePart = dateStr.split('T')[0];
          [year, month, day] = datePart.split('-');
          return `${month}-${day}-${year}`;
        }
        else {
          return dateStr; // Return as-is if format is unknown
        }
      }
      return '';
    } catch (error) {
      console.log("Error formatting date:", dateStr, error);
      return '';
    }
  };

  // Helper function to check if a position is expired
  function isExpired(expiration) {
    console.log("Executing isExpired");

    const today = new Date();

    // Ensure all dates are compared at the start of the day for accuracy
    today.setHours(0, 0, 0, 0);

    // Parse the expiration date string into a Date object
    console.log("isExpired : received expiration = " + expiration);
    const localDateTimeString = expiration + 'T00:00:00'; // Assume midnight
    const expirationDate = new Date(localDateTimeString);
    expirationDate.setHours(0, 0, 0, 0);

    // Check if expiration date is greater than today
    const isFutureDate = expirationDate >= today;
    console.log("isExpired : isFutureDate = " + isFutureDate);
    console.log("isExpired : expirationDate = " + expirationDate);
    console.log("isExpired : today = " + today);

    if (isFutureDate) {
      return false;
    } else {
      return true;
    }
  }

  // Grid column definitions
  const columns = [
    {headerName: "Id", field: "id", hide: true},
    {headerName: "email", field: "email", hide: true},
    {
      headerName: "Delete",
      field: "delete",
      pinned: 'left',
      headerCheckboxSelection: false,
      checkboxSelection: true,
      minWidth:10,
      maxWidth:90,
      cellRenderer: (params) => {
        return (
          <span>
            {params.data.paperTrade && <img src="paper.png" style={{ width: "20px", height: "20px", marginRight: "5px" }} alt="Paper Trade" />}
          </span>
        );
      }
    },
    {
      headerName: "Security",
      field: "security",
      sortable: true,
      filter: true,
      pinned: 'left',
      minWidth: 10,
      maxWidth: 100,
      resizable: true
    },
    {headerName: "Last Sale", field: "lastSale", sortable: true, pinned: 'left', filter: 'agNumberColumnFilter', minWidth:50, maxWidth:100, editable: false, resizable:true},
    {
      headerName: "Expiration",
      field: "expiration",
      sortable: true,
      filter: 'agDateColumnFilter',
      minWidth:50,
      maxWidth:120,
      editable: false,
      resizable:true,
      valueGetter: params => {
        if (!params.data || !params.data.expiration) return '';
        return formatDateForGrid(params.data.expiration);
      }
    },
    {
      headerName: "Profit / Loss %",
      field: "profitLossPercent",
      sortable: true,
      filter: 'agNumberColumnFilter',
      minWidth:50,
      maxWidth:130,
      editable: false,
      resizable:true,
      valueFormatter: params => {
        // Convert to string with two decimal places and append '%'
        return `${params.value}%`;
      },
      cellStyle: (params) => {
        // Check if last sale is outside breakeven range
        const lastSale = parseFloat(params.data.lastSale || 0);
        const upperBreakeven = parseFloat(params.data.upperBreakeven || 0);
        const lowerBreakeven = parseFloat(params.data.lowerBreakeven || 0);
        const profitLoss = parseFloat(params.data.profitLossDollars || 0);
        const isOpen = !params.data.closeTradeDate || params.data.closeTradeDate.length === 0;

        // Apply orange background if outside breakeven range, losing money, not expired, and still open
        if ((lastSale > upperBreakeven || lastSale < lowerBreakeven) &&
            profitLoss < 0 &&
            !isExpired(params.data.exp) &&
            isOpen) {
          return { backgroundColor: '#f9cdaa', color: 'black', fontWeight: 'bold' };
        }
        return { color: 'black', fontWeight: 'bold' };
      }
    },
    {
      headerName: "Profit / Loss $",
      field: "profitLossDollars",
      sortable: true,
      filter: 'agNumberColumnFilter',
      minWidth:50,
      maxWidth:130,
      editable: false,
      resizable:true,
      valueFormatter: params => {
        // Format as currency
        return `$${parseFloat(params.value).toFixed(2)}`;
      },
      cellStyle: (params) => {
        // Check if last sale is outside breakeven range
        const lastSale = parseFloat(params.data.lastSale || 0);
        const upperBreakeven = parseFloat(params.data.upperBreakeven || 0);
        const lowerBreakeven = parseFloat(params.data.lowerBreakeven || 0);
        const profitLoss = parseFloat(params.value || 0);
        const isOpen = !params.data.closeTradeDate || params.data.closeTradeDate.length === 0;

        // Apply orange background if outside breakeven range, losing money, not expired, and still open
        if ((lastSale > upperBreakeven || lastSale < lowerBreakeven) &&
            profitLoss < 0 &&
            !isExpired(params.data.exp) &&
            isOpen) {
          return { backgroundColor: '#f9cdaa', color: 'black', fontWeight: 'bold' };
        }
        return { color: 'black', fontWeight: 'bold' };
      }
    },
    {headerName: "Open Cost", field: "openCost", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:120, editable: false, resizable:true},
    {headerName: "Close Cost", field: "closeCost", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:120, editable: false, resizable:true},

    // Leg 1
    {headerName: "Leg 1 Action", field: "leg1Action", sortable: true, filter: true, minWidth:50, maxWidth:100, resizable:true},
    {headerName: "Leg 1 Type", field: "leg1Type", sortable: true, filter: true, minWidth:50, maxWidth:100, resizable:true},
    {
      headerName: "Leg 1 Strike",
      field: "leg1Strike",
      sortable: true,
      filter: 'agNumberColumnFilter',
      minWidth:50,
      maxWidth:110,
      resizable:true,
      cellStyle: (params) => {
        const lastSale = parseFloat(params.data.lastSale || 0);
        const strike = parseFloat(params.value || 0);
        const legType = params.data.leg1Type;
        // Bold if it's a call and last sale > strike, or put and last sale < strike
        if ((legType === 'call' && lastSale > strike) || (legType === 'put' && lastSale < strike)) {
          return { fontWeight: 'bold' };
        }
        return null;
      }
    },
    {headerName: "Leg 1 Quantity", field: "leg1Quantity", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:110, resizable:true},

    // Leg 2
    {headerName: "Leg 2 Action", field: "leg2Action", sortable: true, filter: true, minWidth:50, maxWidth:100, resizable:true},
    {headerName: "Leg 2 Type", field: "leg2Type", sortable: true, filter: true, minWidth:50, maxWidth:100, resizable:true},
    {
      headerName: "Leg 2 Strike",
      field: "leg2Strike",
      sortable: true,
      filter: 'agNumberColumnFilter',
      minWidth:50,
      maxWidth:110,
      resizable:true,
      cellStyle: (params) => {
        const lastSale = parseFloat(params.data.lastSale || 0);
        const strike = parseFloat(params.value || 0);
        const legType = params.data.leg2Type;
        // Bold if it's a call and last sale > strike, or put and last sale < strike
        if ((legType === 'call' && lastSale > strike) || (legType === 'put' && lastSale < strike)) {
          return { fontWeight: 'bold' };
        }
        return null;
      }
    },
    {headerName: "Leg 2 Quantity", field: "leg2Quantity", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:110, resizable:true},

    // Leg 3
    {headerName: "Leg 3 Action", field: "leg3Action", sortable: true, filter: true, minWidth:50, maxWidth:100, resizable:true},
    {headerName: "Leg 3 Type", field: "leg3Type", sortable: true, filter: true, minWidth:50, maxWidth:100, resizable:true},
    {
      headerName: "Leg 3 Strike",
      field: "leg3Strike",
      sortable: true,
      filter: 'agNumberColumnFilter',
      minWidth:50,
      maxWidth:110,
      resizable:true,
      cellStyle: (params) => {
        const lastSale = parseFloat(params.data.lastSale || 0);
        const strike = parseFloat(params.value || 0);
        const legType = params.data.leg3Type;
        // Bold if it's a call and last sale > strike, or put and last sale < strike
        if ((legType === 'call' && lastSale > strike) || (legType === 'put' && lastSale < strike)) {
          return { fontWeight: 'bold' };
        }
        return null;
      }
    },
    {headerName: "Leg 3 Quantity", field: "leg3Quantity", sortable: true, filter: 'agNumberColumnFilter', minWidth:50, maxWidth:110, resizable:true},

    // Date columns
    {
      headerName: "Open Trade Date",
      field: "openTradeDate",
      sortable: true,
      filter: 'agDateColumnFilter',
      minWidth:50,
      maxWidth:130,
      editable: false,
      resizable:true,
      valueGetter: params => {
        if (!params.data || !params.data.openTradeDate) return '';
        return formatDateForGrid(params.data.openTradeDate);
      }
    },
    {
      headerName: "Close Trade Date",
      field: "closeTradeDate",
      sortable: true,
      sort: 'asc',
      filter: 'agDateColumnFilter',
      minWidth:50,
      maxWidth:130,
      editable: false,
      resizable:true,
      valueGetter: params => {
        if (!params.data || !params.data.closeTradeDate) return '';
        return formatDateForGrid(params.data.closeTradeDate);
      }
    },

    // Details column at the end
    {
      headerName: "Details",
      field: "details",
      minWidth: 50,
      maxWidth: 100,
      editable: false,
      resizable: true,
      cellRenderer: (params) => {
        const handleClick = () => {
          handleEditClick(params.data);
        };
        return <span onClick={handleClick} style={{cursor: 'pointer'}}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;
      }
    },
  ];

  const gridRef = useRef();

  useEffect(() => {
    if (typeof(email.current) === 'undefined') {
      getUserInfo()
        .then(async () => {
          await getMyTransactions(email.current);
        })
    } else {
      if (!calledGetMyTransactions.current) {
        getMyTransactions(email.current);
      }
    }
  }, []);

  useEffect(() => {
    if (recsWereDeleted > 0) {
      getMyTransactions(email.current);
      setRecsWereDeleted(-1);
    }
  }, [recsWereDeleted]);

  // Reset edit mode when navigating to a different portfolio or clicking same portfolio button
  useEffect(() => {
    if (isEditing) {
      setIsEditing(false);
    }
  }, [location.pathname, location.key]);

  const handleDelete = async () => {
    console.log("Executing handleDelete");
    const selectedRows = gridRef.current.api.getSelectedRows();
    console.log("selectedRows = ", selectedRows);

    if (selectedRows.length === 0) {
      setError("No records selected for deletion");
      setDisplayMessage("");
      return;
    }

    const ids = selectedRows.map(row => row.id);
    console.log("ids to delete = ", ids);

    try {
      setDisplayMessage("Deleting records...");
      setError("");

      // Delete records using the same pattern as Iron Condor
      for (let id of ids) {
        const deletePath = '/deleteButterflyTransaction/' + id;
        await get({
          apiName: myAPI,
          path: deletePath,
        }).response;
      }

      setDisplayMessage("");
      setError("");
      setRecsWereDeleted(ids.length);
    } catch (error) {
      console.log("Error deleting records:", error);
      setError("Error deleting records: " + error.message);
      setDisplayMessage("");
    }
  };

  const handleEditClick = (record) => {
    selectedRecord.current = record;
    setIsEditing(true);
  };

  const handleEditBack = async () => {
    setIsEditing(false);
    // Reload transactions to show updated data
    await getMyTransactions(email.current);
  };

  const formatCurrency = (value) => {
    const num = parseFloat(value) || 0;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(num);
  };

  const getRowStyle = (params) => {
    const profitLoss = parseFloat(params.data.profitLossDollars || 0);
    if (profitLoss > 0) {
      return { backgroundColor: '#d1fae5', color: 'black' };
    } else if (profitLoss < 0) {
      return { backgroundColor: '#fee2e2', color: 'black' };
    }
    return null;
  };

  return (
    <AppLayout signOut={signOut}>
      <div style={{ maxWidth: '1600px', margin: '0 auto', padding: '24px' }}>
        {!isEditing ? (
          <>
            {/* Page Title */}
            <div style={{ marginBottom: '24px' }}>
              <h1 style={{ fontSize: '28px', fontWeight: '700', color: 'rgba(0, 0, 0, 0.9)' }}>
                Butterfly Portfolio
              </h1>
            </div>

            {/* Error/Success Messages */}
            {error && (
              <div className="blink_me_red" style={{
                marginBottom: '16px',
                textAlign: 'center',
                fontSize: '16px',
                padding: '12px'
              }}>
                {error}
              </div>
            )}
            {displayMessage && (
              <div className="blink_me" style={{
                marginBottom: '16px',
                textAlign: 'center',
                fontSize: '16px',
                padding: '12px',
                color: 'green'
              }}>
                {displayMessage}
              </div>
            )}

            {/* Summary Cards */}
            <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
              <div style={{
                flex: '1',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(229, 231, 235, 1)',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: 'rgba(107, 114, 128, 1)',
                  marginBottom: '8px',
                  fontWeight: '600'
                }}>
                  Unrealized Profit
                </div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: parseFloat(unrealizedProfit.current) <= 0 ? '#ef4444' : '#10b981'
                }}>
                  {formatCurrency(unrealizedProfit.current)}
                </div>
              </div>

              <div style={{
                flex: '1',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(229, 231, 235, 1)',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: 'rgba(107, 114, 128, 1)',
                  marginBottom: '8px',
                  fontWeight: '600'
                }}>
                  Realized Profit
                </div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: parseFloat(realizedProfit.current) <= 0 ? '#ef4444' : '#10b981'
                }}>
                  {formatCurrency(realizedProfit.current)}
                </div>
              </div>

              <div style={{
                flex: '1',
                background: 'rgba(255, 255, 255, 0.95)',
                border: '1px solid rgba(229, 231, 235, 1)',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)'
              }}>
                <div style={{
                  fontSize: '14px',
                  color: 'rgba(107, 114, 128, 1)',
                  marginBottom: '8px',
                  fontWeight: '600'
                }}>
                  Invested in Market
                </div>
                <div style={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: 'rgba(0, 0, 0, 0.9)'
                }}>
                  {formatCurrency(investedInMarket.current)}
                </div>
              </div>
            </div>

            {/* Grid */}
            <div className="ag-theme-quartz" style={{
              height: 'calc(100vh - 480px)',
              minHeight: '400px',
              width: '100%',
              '--ag-header-height': '48px',
              '--ag-row-height': '52px',
              '--ag-header-background-color': 'rgba(249, 250, 251, 1)',
              '--ag-odd-row-background-color': 'rgba(255, 255, 255, 1)',
              '--ag-header-foreground-color': 'rgba(17, 24, 39, 1)',
              '--ag-border-color': 'rgba(229, 231, 235, 1)',
              '--ag-row-hover-color': 'rgba(243, 244, 246, 1)',
              '--ag-selected-row-background-color': 'rgba(219, 234, 254, 1)'
            }}>
              <AgGridReact
                rowData={rowDataState}
                columnDefs={columns}
                suppressRowClickSelection={true}
                rowSelection={'multiple'}
                ref={gridRef}
                getRowStyle={getRowStyle}
                defaultColDef={{
                  sortable: true,
                  filter: true,
                  resizable: true,
                }}
              />
            </div>

            {/* Action Buttons */}
            <div style={{
              display: 'flex',
              gap: '12px',
              justifyContent: 'center',
              marginTop: '24px'
            }}>
              <button
                onClick={handleDelete}
                style={{
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Delete Selected
              </button>
              <button
                onClick={() => navigate('/butterflyMenu')}
                style={{
                  padding: '12px 32px',
                  background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(107, 114, 128, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                Back to Menu
              </button>
            </div>
          </>
        ) : (
          <EditForm record={selectedRecord.current} onBack={handleEditBack} />
        )}
      </div>
    </AppLayout>
  );
}

export default MyPortfolioButterfly;
